import {useMemo} from "react";

import {isAlertsBellTopic} from "../lib/notification-feed-topics";
import {useNotificationFeedStore} from "../store";

/** Unread alert rows (shift, stored vehicle, briefing board) — excludes direct_message. */
export function useAlertsFeedUnreadCount() {
  const items = useNotificationFeedStore((state) => state.items);

  return useMemo(
    () =>
      items.filter(
        (item) =>
          isAlertsBellTopic(item.topic) && !item.read_at && !item.discarded_at,
      ).length,
    [items],
  );
}
